module.exports = __webpack_public_path__ + "static/media/Velasca - Dk Chocolate_Orange.6ad6a91f.jpg";